// Turns a colour name typed in the admin ("Peacock Blue", "Maroon", "#1e3a8a") into a real colour for swatches.
const NAMED = {
  green: "#2f7d4f", emerald: "#0f7b55", sage: "#9caf88", bottle: "#0b4d2c", olive: "#6b7a2a", mint: "#a8dcc0", parrot: "#3fae2a",
  red: "#c0262d", crimson: "#991b1b", maroon: "#6b1d2a", wine: "#5e1224", rani: "#d6176b", magenta: "#c2185b", ruby: "#9b111e",
  pink: "#e88ca6", rose: "#e7a1b0", peach: "#f6b99b", coral: "#f2735b", onion: "#c98a8f",
  blue: "#2563eb", peacock: "#0f6b78", navy: "#1e2a5a", royal: "#1d3fa8", sky: "#7cc4ef", teal: "#0f766e", turquoise: "#14b8a6", firozi: "#2bb3b1",
  ivory: "#f4efe1", white: "#ffffff", offwhite: "#f6f2e8", cream: "#f3e9d2", beige: "#d9c7a7", silver: "#c0c0c0",
  gold: "#d4af37", golden: "#d4af37", yellow: "#eab308", mustard: "#c9a227", lemon: "#f5e663", haldi: "#e3a21a",
  orange: "#ea7a1a", rust: "#b7410e", saffron: "#f4a024",
  black: "#111111", grey: "#9ca3af", gray: "#9ca3af", charcoal: "#36454f",
  purple: "#7e22ce", violet: "#6d28d9", lavender: "#b9a6e8", lilac: "#c8a2c8", mauve: "#b784a7",
  brown: "#7c4a2d", coffee: "#6f4e37", copper: "#b87333",
};

const cssColor = (v) => {
  try { return typeof CSS !== "undefined" && CSS.supports && CSS.supports("color", v) ? v : null; } catch { return null; }
};

export function colorToCss(name) {
  const raw = (name || "").trim();
  if (!raw) return null;
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)) return raw;
  const words = raw.toLowerCase().replace(/[^a-z\s-]/g, " ").split(/[\s-]+/).filter(Boolean);
  // last word usually carries the hue ("Peacock Blue"); a known first word like "peacock" refines it
  if (words.length > 1 && NAMED[words[0]] && ["peacock", "rani", "bottle", "royal", "navy", "onion", "parrot", "haldi", "firozi"].includes(words[0])) return NAMED[words[0]];
  for (const w of [...words].reverse()) if (NAMED[w]) return NAMED[w];
  const joined = words.join("");
  return NAMED[joined] || cssColor(joined) || cssColor(words[words.length - 1] || "") || null;
}

/** A product can list several colours: "Blue, Gold" or "Red & Green". */
export const splitColors = (value) => (value || "").split(/\s*(?:,|\/|&|\band\b)\s*/i).map((s) => s.trim()).filter(Boolean);

export function ColorDot({ color, size = 16, className = "" }) {
  const c = colorToCss(color) || "#d4d4d4";
  return (
    <span aria-hidden="true" className={`inline-block rounded-full shrink-0 ${className}`}
          style={{ width: size, height: size, background: c, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)" }}/>
  );
}
